
<!-- <div class="bottom_nav"> -->
<div class="d-flex justify-content-between">
  <div *ngIf="UserCondition">
    <ul class=" nav nav-pills d-flex justify-content-between">
      <li class="nav-item col-xs-3">
        <a [routerLink]="['../', 'food-menu']" routerLinkActive="active" class="nav-link"
          #rla="routerLinkActive">
          
          <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />

          <span class="nav__text">Menu</span>
        </a>
      </li>
      <li class="nav-item col-xs-3">
        <a [routerLink]="['../', 'order-menu']" routerLinkActive="active" class="nav-link"  #rlas="routerLinkActive"><span class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
          <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
          <!-- <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon> -->
          <span class="nav__text">Cart</span>
        </a>
      </li>
      <li class="nav-item col-xs-3">
        <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link"  #rlag="routerLinkActive">
          <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">
          
          <span class="nav__text">Orders</span>
        </a>
      </li>
      <li class="nav-item col-xs-3">
        <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link"  #rlap="routerLinkActive">
          <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
          <span class="nav__text">Profile</span>
        </a>
      </li>
    </ul>
  </div>
</div>
<!-- </div> -->